export default __webpack_public_path__ + "static/media/plurifonds.icon.4fb4afb8.svg";